@use "/src/styles/functions.scss";

.container {
  display: flex;
  justify-content: space-between;
  gap: functions.toRem(4);
}

.label {
  margin-bottom: functions.toRem(6);
  display: flex;
  align-items: center;
  gap: functions.toRem(4);
}

.isRequired {
  color: functions.getColor(var(--theme-secondary-600));
}
